import { createAction } from 'typesafe-actions';
import { LDFlagSet, LDUser } from 'launchdarkly-js-client-sdk';

export const setFeatureFlags = createAction('featureFlags/SET_FEATURE_FLAGS')<LDFlagSet>();
export const setLDUser = createAction('featureFlags/SET_LD_USER')<LDUser>();
